import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Sword } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = '/api';

export default function HeroOfTheDay() {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const response = await axios.get(`${API}/heroes/hero-of-the-day`);
        setHero(response.data.hero);
      } catch (error) {
        console.error("Hero fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHero();
  }, []);

  if (loading) {
    return (
      <Card className="p-4 bg-gradient-to-br from-amber-500/10 to-amber-600/5 border-amber-500/20 animate-pulse">
        <div className="h-24"></div>
      </Card>
    );
  }

  if (!hero) return null;

  return (
    <Card className="p-4 bg-gradient-to-br from-amber-500/10 to-amber-600/5 border-amber-500/20 hover:border-amber-500/40 transition-all duration-300">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center flex-shrink-0">
          <Sword className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-white truncate">Günün Kahramanı</h3>
          <Badge className="bg-amber-500/80 text-white text-xs mt-1">{hero.period}</Badge>
        </div>
      </div>
      
      <h4 className="text-lg font-bold text-amber-200 mb-1 truncate">{hero.name}</h4>
      <p className="text-white/70 text-xs line-clamp-2 mb-2">{hero.bio}</p>
      
      {hero.achievement && (
        <p className="text-amber-100/80 text-xs italic line-clamp-1">
          🏆 {hero.achievement}
        </p>
      )}
    </Card>
  );
}
